"use strict";

Shopify.theme.jsTestimonials = {
  init: function init($section) {
    this.createSlider();
    $(".pyp-rating-count").click(function() {
      $('html,body').animate({
          scrollTop: $(".testimonials").offset().top},
          'slow');
    });
  },
  createSlider: function createSlider() {
    var $testimonialSlider = $('[data-testimonial-slider]').flickity({
      wrapAround: true,
      initialIndex: 1,
      prevNextButtons: false,
      pageDots: true,
      watchCSS: true,
      on: {
        ready: function ready() {
          // Reset layout to avoid collapsing issues
          setTimeout(function () {
            $('[data-testimonial-slider]').flickity('resize');
          }, 500);
        }
      }
    }); // Reset layout to avoid collapsing issues

    
    $('body').on('click', '.prev-style .prev-button', function () {
      $testimonialSlider.flickity('previous');
    });
    $('body').on('click', '.next-style .next-button', function () {
      $testimonialSlider.flickity('next');
    });

    $(".testimonials .flickity-page-dots").addClass("buttons-enabled");
    
    // Define next prev buttons
    $(".flickity-page-dots.buttons-enabled").prepend(
      '<li class="prev-wrapper">' +
        '<div class="prev-style relative">' +
          '<div class="clf prepped-font">' +
              '<div class="slider-prev absolute-fill pointer-events-pointer"></div>' +
              '<span class="prev-button">Prev</span>' +
          '</div>' +
        '</div>' +
      '</li>'
    );

    $(".flickity-page-dots.buttons-enabled").append(
        '<li class="next-wrapper">' +
          '<div class="next-style relative">' +
            '<div class="clf prepped-font">' +
              '<div class="slider-next absolute-fill pointer-events-pointer"></div>' +
              '<span class="next-button">Next</span>' +
            '</div>' +
          '</div>' +
        '</li>'     
    );
  },
  blockSelect: function blockSelect($section, blockId) {
    var $testimonialSlider = $section.find('[data-testimonial-slider]');
    var slideIndex = $('#shopify-section-' + blockId).data('testimonial-index');
    $testimonialSlider.flickity('select', slideIndex, true, true);
  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
    $('.testimonial__nav--prev').off();
    $('.testimonial__nav--next').off();
  }
};